import cvDataJson from '../data/cvData.json';
import { CVData } from '../types/cvTypes';
import { SITE_URL } from './Seo';

const cvData: CVData = cvDataJson as CVData;
const { personalInfo } = cvData;

const PERSON_ID = `${SITE_URL}/#person`;

const [locality, country] = personalInfo.location.split(',').map((part) => part.trim());

const person = {
  '@type': 'Person',
  '@id': PERSON_ID,
  name: personalInfo.name,
  url: SITE_URL,
  image: personalInfo.avatar,
  jobTitle: personalInfo.title,
  description: personalInfo.summary,
  sameAs: [personalInfo.github, personalInfo.linkedin],
  worksFor: { '@type': 'Organization', name: cvData.experience[0].company },
  alumniOf: { '@type': 'CollegeOrUniversity', name: cvData.education[0].institution },
  address: { '@type': 'PostalAddress', addressLocality: locality, addressCountry: country },
};

export const portfolioSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    person,
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: personalInfo.name,
      description: personalInfo.summary,
      publisher: { '@id': PERSON_ID },
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Portfolio',
      url: `${SITE_URL}/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'CV & Skills',
      url: `${SITE_URL}/cv`,
    },
  ],
};

export const cvSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfilePage',
  '@id': `${SITE_URL}/cv#profilepage`,
  url: `${SITE_URL}/cv`,
  name: `CV & Skills — ${personalInfo.name}`,
  mainEntity: person,
};
